import React, { useEffect } from 'react';
import { useTelegram } from './TelegramProvider';

export const TelegramNavigation = ({ currentPage, onPageChange }) => {
    const { tg, hapticFeedback } = useTelegram();

    useEffect(() => {
        if (tg) {
            // Настройка кнопки "Назад" в Telegram
            const handleBackButton = () => {
                if (currentPage !== 'home') {
                    onPageChange('home');
                } else {
                    tg.close();
                }
            };

            tg.BackButton.onClick(handleBackButton);

            if (currentPage !== 'home') {
                tg.BackButton.show();
            } else {
                tg.BackButton.hide();
            }

            return () => {
                tg.BackButton.offClick(handleBackButton);
            };
        }
    }, [currentPage, tg, onPageChange]);

    const handleNavClick = (page) => {
        hapticFeedback('light');
        onPageChange(page);
    };

    const navItems = [
        { id: 'home',     icon: '🏠', label: 'Home'    },
        { id: 'game',     icon: '🎰', label: 'Games'   },
        { id: 'presale',  icon: '🚀', label: 'Presale' },
        { id: 'stake',    icon: '🏦', label: 'Staking' },
        { id: 'vip',      icon: '👑', label: 'VIP'     },
    ];

    return (
        <div className="telegram-navigation">
            <div className="nav-container">
                {navItems.map((item) => (
                    <button
                        key={item.id}
                        className={`nav-item ${currentPage === item.id ? 'active' : ''}`}
                        onClick={() => handleNavClick(item.id)}
                    >
                        <div className="nav-icon-wrap">{item.icon}</div>
                        <span className="nav-label">{item.label}</span>
                    </button>
                ))}
            </div>
        </div>
    );
};
